import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../../ui/modal/modal-layout-right.component';
export interface ICheckoutDeliveryInfoModalBlockDataContent {
    title: string;
    copy: string;
}

export const CHECKOUT_DELIVERY_INFO_MODAL_ID = 'checkoutDeliveryInfoModal';

@DfCmsModal({
    id: CHECKOUT_DELIVERY_INFO_MODAL_ID,
    name: 'Checkout delivery info modal',
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName),
        modalClass: 'bg-col-w p-a-0'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@ICmsComponent<CheckoutDeliveryInfoModalComponent>({
    id: 'checkout-delivery-info-modal',
    block: {
        url: 'checkout-delivery-info-modal'
    },
    name: 'Checkout delivery info modal',
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'copy',
            type: NICmsContentField.EFieldType.text,
            title: 'Copy',
            required: true
        }
    ]
})
@Component({
    selector: 'checkout-delivery-info-modal',
    templateUrl: './checkout-delivery-info-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalLayoutRightComponent, CommonModule, ICmsClientModule]
})
export class CheckoutDeliveryInfoModalComponent extends UiComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: ICheckoutDeliveryInfoModalBlockDataContent;
}
